/**
 * UN.BASED — Ready to scale (4 steps, validation, progress, conditional meeting embed).
 * Optional: POST multipart to Zapier before native Shopify contact submit (Klaviyo / SMS stacks).
 */
(function () {
  function getVal(form, name) {
    try {
      var fd = new FormData(form);
      var v = fd.get(name);
      return v != null && v !== '' ? String(v).trim() : '';
    } catch (e) {
      return '';
    }
  }

  function getRadioValue(form, name) {
    var nodes = form.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].name === name && nodes[i].checked) return String(nodes[i].value || '').trim();
    }
    return '';
  }

  function uuid() {
    try {
      if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
    } catch (e) {}
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  function isSafeWebhookUrl(u) {
    if (!u || typeof u !== 'string') return false;
    try {
      var p = new URL(u.trim());
      return p.protocol === 'https:' || p.protocol === 'http:';
    } catch (e) {
      return false;
    }
  }

  function syncTrafficField(root) {
    var field = root.querySelector('[data-ub-traffic-field]');
    if (!field) return;
    var vals = [];
    Array.prototype.forEach.call(root.querySelectorAll('[data-ub-traffic-cb]:checked'), function (cb) {
      vals.push(cb.value);
    });
    field.value = vals.join(', ');
  }

  function tierFromInput(el) {
    if (!el) return '0';
    var t = el.getAttribute('data-ub-rev-tier') || el.getAttribute('data-ub-budget-tier');
    return t === '1' ? '1' : '0';
  }

  function qualifiesForMeeting(form) {
    var rev = form.querySelector('input[name="contact[Monthly revenue]"]:checked');
    var bud = form.querySelector('input[name="contact[Monthly ad budget]"]:checked');
    return tierFromInput(rev) === '1' || tierFromInput(bud) === '1';
  }

  function updateMeetingEmbed(root, form) {
    var wrap = root.querySelector('[data-ub-scale-meeting]');
    var iframe = root.querySelector('[data-ub-meeting-iframe]');
    var url = (root.getAttribute('data-meeting-url') || '').trim();
    if (!wrap || !iframe) return;
    if (!url) {
      wrap.hidden = true;
      iframe.removeAttribute('src');
      return;
    }
    var step = parseInt(root.getAttribute('data-ub-current-step') || '1', 10);
    var show = step === 4 && qualifiesForMeeting(form);
    if (show) {
      wrap.hidden = false;
      if (iframe.getAttribute('src') !== url) {
        iframe.setAttribute('src', url);
      }
    } else {
      wrap.hidden = true;
      iframe.removeAttribute('src');
    }
  }

  function phoneUpdatesOptIn(root) {
    var cb = root.querySelector('[data-ub-scale-phone-updates]');
    return !!(cb && cb.checked);
  }

  /** If shopper did not opt in for application updates, strip phone so it is not sent to Shopify or Zapier. */
  function sanitizePhoneForSubmit(form, root) {
    var phone = form.querySelector('input[name="contact[Phone]"]');
    if (!phone) return;
    if (!phoneUpdatesOptIn(root)) {
      phone.value = '';
      phone.required = false;
      phone.setCustomValidity('');
    }
  }

  function buildBody(form, root) {
    syncTrafficField(root);
    var phoneVal = getVal(form, 'contact[Phone]');
    var lines = [
      'READY TO SCALE — APPLICATION',
      '==============================',
      '',
      'Name: ' + getVal(form, 'contact[Name]'),
      'Email: ' + getVal(form, 'contact[email]'),
    ];
    if (phoneVal) {
      lines.push('Phone: ' + phoneVal);
    }
    lines.push(
      'Brand: ' + getVal(form, 'contact[Brand name]'),
      'Website: ' + getVal(form, 'contact[Website URL]'),
      'Instagram: ' + getVal(form, 'contact[Instagram]'),
      '',
      'Monthly revenue: ' + getRadioValue(form, 'contact[Monthly revenue]'),
      'Traffic sources: ' + getVal(form, 'contact[Traffic sources]'),
      '',
      'Primary growth goal: ' + getRadioValue(form, 'contact[Primary growth goal]'),
      'Biggest challenge: ' + getVal(form, 'contact[Biggest challenge]'),
      'Details: ' + getVal(form, 'contact[Challenge details]'),
      '',
      'Monthly ad budget: ' + getRadioValue(form, 'contact[Monthly ad budget]'),
      'Team size: ' + getVal(form, 'contact[Team size]'),
      'Timeline: ' + getRadioValue(form, 'contact[Timeline readiness]')
    );
    return lines.join('\n');
  }

  /** Multipart for Zapier / Klaviyo — field names stable for mapping. */
  function buildZapierFormData(form, root, submissionId) {
    syncTrafficField(root);
    var summary = buildBody(form, root);
    var fd = new FormData();
    fd.append('submission_id', submissionId);
    fd.append('form_type', 'ready_to_scale');
    fd.append('name', getVal(form, 'contact[Name]'));
    fd.append('email', getVal(form, 'contact[email]'));
    fd.append('phone_updates_opt_in', phoneUpdatesOptIn(root) ? 'yes' : 'no');
    fd.append('phone', getVal(form, 'contact[Phone]'));
    fd.append('brand', getVal(form, 'contact[Brand name]'));
    fd.append('website_url', getVal(form, 'contact[Website URL]'));
    fd.append('instagram', getVal(form, 'contact[Instagram]'));
    fd.append('monthly_revenue', getRadioValue(form, 'contact[Monthly revenue]'));
    fd.append('traffic_sources', getVal(form, 'contact[Traffic sources]'));
    fd.append('primary_growth_goal', getRadioValue(form, 'contact[Primary growth goal]'));
    fd.append('biggest_challenge', getVal(form, 'contact[Biggest challenge]'));
    fd.append('challenge_details', getVal(form, 'contact[Challenge details]'));
    fd.append('monthly_ad_budget', getRadioValue(form, 'contact[Monthly ad budget]'));
    fd.append('team_size', getVal(form, 'contact[Team size]'));
    fd.append('timeline_readiness', getRadioValue(form, 'contact[Timeline readiness]'));
    fd.append('qualifies_meeting', qualifiesForMeeting(form) ? 'yes' : 'no');
    var sms = form.querySelector('[data-ub-scale-sms]');
    fd.append('sms_opt_in', sms && sms.checked ? 'yes' : 'no');
    fd.append('application_summary', summary);
    if (root.getAttribute('data-shop-domain')) {
      fd.append('shop', root.getAttribute('data-shop-domain').trim());
    }
    if (typeof window !== 'undefined' && window.location && window.location.href) {
      fd.append('form_url', window.location.href);
    }
    return fd;
  }

  function setZapierStatus(root, message) {
    var el = root.querySelector('[data-ub-scale-zapier-status]');
    if (!el) return;
    if (!message) {
      el.hidden = true;
      el.textContent = '';
      return;
    }
    el.hidden = false;
    el.textContent = message;
  }

  function firstInvalidInStep(stepEl) {
    if (!stepEl) return null;
    var controls = stepEl.querySelectorAll('input, select, textarea');
    for (var i = 0; i < controls.length; i++) {
      var el = controls[i];
      if (el.type === 'hidden') continue;
      if (!el.checkValidity()) return el;
    }
    return null;
  }

  function validateStep(step, root, form) {
    var stepEl = root.querySelector('[data-ub-scale-step="' + step + '"]');
    if (!stepEl) return true;

    if (step === 2) {
      syncTrafficField(root);
      var rev = form.querySelector('input[name="contact[Monthly revenue]"]:checked');
      if (!rev) {
        var firstRadio = stepEl.querySelector('input[name="contact[Monthly revenue]"]');
        if (firstRadio) firstRadio.focus();
        return false;
      }
      var checkedTraffic = root.querySelectorAll('[data-ub-traffic-cb]:checked');
      if (!checkedTraffic.length) {
        var firstCb = root.querySelector('[data-ub-traffic-cb]');
        if (firstCb) firstCb.focus();
        return false;
      }
    }

    var bad = firstInvalidInStep(stepEl);
    if (bad) {
      bad.reportValidity();
      bad.focus();
      return false;
    }
    return true;
  }

  function init(root) {
    if (root.getAttribute('data-ub-scale-init') === '1') return;
    if (root.classList && root.classList.contains('ub-custom-intake')) return;
    var form = root.querySelector('form.ub-scale-form__form');
    if (!form) return;
    root.setAttribute('data-ub-scale-init', '1');

    var stepEls = root.querySelectorAll('[data-ub-scale-step]');
    var nextBtn = root.querySelector('[data-ub-scale-next]');
    var backBtn = root.querySelector('[data-ub-scale-back]');
    var submitBtn = root.querySelector('[data-ub-scale-submit]');
    var progressFill = root.querySelector('[data-ub-scale-progress]');
    var bodyField = root.querySelector('[data-ub-scale-body]');
    var dots = root.querySelectorAll('[data-ub-scale-dot]');

    var total = parseInt(root.getAttribute('data-total-steps') || '4', 10);
    var step = 1;

    function setStepAttr(n) {
      root.setAttribute('data-ub-current-step', String(n));
    }

    function updateProgressUI(n) {
      if (progressFill) {
        progressFill.style.width = (n / total) * 100 + '%';
      }
      Array.prototype.forEach.call(dots, function (dot, i) {
        var idx = i + 1;
        dot.classList.toggle('is-active', idx === n);
        dot.classList.toggle('is-complete', idx < n);
        dot.setAttribute('aria-current', idx === n ? 'step' : 'false');
        var item = dot.closest('.ub-scale-progress__item');
        if (item) {
          item.classList.toggle('is-active', idx === n);
          item.classList.toggle('is-complete', idx < n);
        }
      });
    }

    function showStep(n) {
      step = n;
      setStepAttr(n);
      Array.prototype.forEach.call(stepEls, function (el) {
        var sn = parseInt(el.getAttribute('data-ub-scale-step'), 10);
        var on = sn === n;
        el.hidden = !on;
        el.classList.toggle('ub-scale-form__step--hidden', !on);
        if (on) {
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
        }
      });
      updateProgressUI(n);
      if (backBtn) backBtn.hidden = n === 1;
      if (nextBtn) nextBtn.hidden = n === total;
      if (submitBtn) submitBtn.hidden = n !== total;
      syncTrafficField(root);
      updateMeetingEmbed(root, form);
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-ub-traffic-cb]'), function (cb) {
      cb.addEventListener('change', function () {
        syncTrafficField(root);
      });
    });

    Array.prototype.forEach.call(
      form.querySelectorAll('input[name="contact[Monthly revenue]"], input[name="contact[Monthly ad budget]"]'),
      function (el) {
        el.addEventListener('change', function () {
          updateMeetingEmbed(root, form);
        });
      }
    );

    showStep(1);

    var phoneOptCb = root.querySelector('[data-ub-scale-phone-updates]');
    var phoneOptBtn = root.querySelector('[data-ub-scale-phone-updates-btn]');
    var phoneField = form.querySelector('input[name="contact[Phone]"]');

    function syncPhoneUpdatesUi() {
      var on = !!(phoneOptCb && phoneOptCb.checked);
      if (phoneField) {
        phoneField.required = on;
        phoneField.setCustomValidity('');
      }
      if (phoneOptBtn) {
        phoneOptBtn.classList.toggle('is-selected', on);
        phoneOptBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    }

    if (phoneOptBtn && phoneOptCb) {
      phoneOptBtn.addEventListener('click', function () {
        phoneOptCb.checked = !phoneOptCb.checked;
        phoneOptCb.dispatchEvent(new Event('change', { bubbles: true }));
      });
      phoneOptCb.addEventListener('change', syncPhoneUpdatesUi);
      syncPhoneUpdatesUi();
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (!validateStep(step, root, form)) return;
        if (step < total) showStep(step + 1);
      });
    }

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        if (step > 1) showStep(step - 1);
      });
    }

    form.addEventListener(
      'keydown',
      function (e) {
        if (e.key !== 'Enter') return;
        if (e.target.tagName === 'TEXTAREA') return;
        var cur = parseInt(root.getAttribute('data-ub-current-step') || '1', 10);
        if (cur < total) {
          e.preventDefault();
          if (nextBtn) nextBtn.click();
        }
      },
      true
    );

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var cur = parseInt(root.getAttribute('data-ub-current-step') || '1', 10);
      if (cur !== total) {
        if (nextBtn) nextBtn.click();
        return;
      }
      syncTrafficField(root);
      for (var s = 1; s <= total; s++) {
        if (!validateStep(s, root, form)) {
          showStep(s);
          return;
        }
      }

      if (phoneUpdatesOptIn(root) && !getVal(form, 'contact[Phone]').trim()) {
        var phoneInput = form.querySelector('input[name="contact[Phone]"]');
        if (phoneInput) {
          phoneInput.setCustomValidity('Enter your phone number to receive application updates.');
          phoneInput.reportValidity();
          phoneInput.setCustomValidity('');
        }
        showStep(1);
        return;
      }

      sanitizePhoneForSubmit(form, root);
      if (bodyField) bodyField.value = buildBody(form, root);

      var webhook = (root.getAttribute('data-zapier-webhook') || '').trim();
      if (!webhook || !isSafeWebhookUrl(webhook)) {
        HTMLFormElement.prototype.submit.call(form);
        return;
      }

      setZapierStatus(root, '');

      var submissionId = uuid();
      var fd = buildZapierFormData(form, root, submissionId);
      if (submitBtn) submitBtn.disabled = true;

      fetch(webhook, {
        method: 'POST',
        body: fd,
        mode: 'cors',
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Zapier ' + res.status);
          HTMLFormElement.prototype.submit.call(form);
        })
        .catch(function () {
          setZapierStatus(
            root,
            root.getAttribute('data-msg-zapier-error') ||
              'We could not send your application to our automation. Check your connection and try again.'
          );
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  function initAllScaleForms(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(root.querySelectorAll('.ub-scale-form'), function (el) {
      init(el);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllScaleForms(document);
  });

  if (document.readyState !== 'loading') {
    initAllScaleForms(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target;
    if (!target || !target.querySelectorAll) return;
    initAllScaleForms(target);
  });
})();
